import AxiosInstance from '../Api/axiosInstance';
import { apiEndpoints } from '../Api/apiEndpoints';
import md5 from "md5";
const { createSlice } = require("@reduxjs/toolkit");
const Confdata = window['runConfig'];

const SignUpReducer = createSlice({
    name: "signup",
    initialState: {
        language: "en",
        initailLag: 'en',
        signupsucess: false,
        errormessage: '',
        passwordVisible: false,
        userjson: '',
        encryptedPass: "",
        randomkey: "",
        encryptedData: "",
        success: false,
        verifyscreenone: {
            EmailId: '',
            OTP: ''
        },
        signupuser: {
            EmailId: '',
            password: '',
            confirmpassword: ''
        },
    },
    reducers: {
        setLanguage: (state, { payload }) => {
            state.language = payload;
        },
        setInitailLag: (state, { payload }) => {
            state.initailLag = payload;
        },
        setsuccess(state, action) {
            state.success = action.payload;
        },
        setencryptedData(state, action) {
            state.encryptedData = action.payload;
        },
        setUserJson(state, action) {
            state.userjson = action.payload;
        },
        setVerifyScreenOne: (state, { payload }) => {
            state.verifyscreenone = payload;
        },
        setSignUpUser: (state, { payload }) => {
            state.signupuser = payload;
        },
        setRandomKey: (state, { payload }) => {
            state.randomkey = payload;
        },

        setencryptedPass(state, action) {
            state.encryptedPass = action.payload;
        },

        setsignupsucess(state, action) {
            state.signupsucess = action.payload;
        },
        seterrormsg(state, action) {
            state.errormessage = action.payload;
        },
        setpasswordVisible(state, action) {
            state.passwordVisible = action.payload;
        },
    },
});

const { actions } = SignUpReducer;

export const {
    setLanguage,
    setInitailLag,
    setUserJson,
    setsuccess,
    setencryptedData,
    setVerifyScreenOne,
    setRandomKey,
    setSignUpUser,
    setencryptedPass,
    setsignupsucess,
    seterrormsg,
    setpasswordVisible,
} = SignUpReducer.actions;

export const UserSignup = (data, encryptedData) => async (dispatch, getState) => {
    const headers = {
        'token': Confdata.token,
        'token_secret': Confdata.tokensecret
    };
    const { encrypted } = getState().signup.encryptedData;
    const res = await AxiosInstance.post(apiEndpoints().SIGNUP_API, data, { headers: headers })

    if (res.data.status === 1 || res.data.status === 3) {
        setTimeout(() => {
            window.location.href = `${Confdata.apiUrl}/jodoworldsignon/AutoLoginServlet?a=${encryptedData}`
        }, 1500)
    } else {
        dispatch(setsuccess(false));
        dispatch(seterrormsg(res.data.statusdesc ? res.data.statusdesc : "A technical error has occurred. Please re-try after some time."));
    }
};

export const returnKey = (pass) => async (dispatch) => {
    try {
        const response = await AxiosInstance.get(
            apiEndpoints().GET_PASSWOED_KEY + 'LoginWebserviceHandle?methodname=GenerateKey&data={"appid":1}'
        );
        if (response.status === 200) {
            dispatch(setsuccess(true));
            const passKey = `${md5(pass)}${response.data.keyvalue1}`;
            dispatch(setencryptedPass(md5(passKey)));
            dispatch(setRandomKey(response.data.keyvalue2));
        }
    } catch (error) {
        dispatch(setsuccess(false))
    }
};
export default SignUpReducer.reducer;